// helpers for disabled rules
export const isReaderAction01Disabled = (item, filters) => {
  // filters === filterApplied
  const rd = filters[0];
  return (
    ((rd === 1 || rd === 2) && (item.key === 7 || item.key === 8)) ||
    (rd === 3 && item.key === 8) ||
    (rd === 4 && item.key === 7)
  );
};

export const isTextBehaviourDisabled = (item, filters) => {
  const rd = filters[0],
    sp = filters[1],
    flip = filters[2];
  return (
    ((rd === 1 || rd === 2) && item.key === 11) ||
    (rd === 3 && sp === 5 && flip === 7 && item.key === 10) ||
    (rd === 3 && sp === 5 && flip === 9 && item.key === 11) ||
    (rd === 3 && sp === 6) ||
    (rd === 4 && sp === 6) ||
    (rd === 4 && sp === 5 && flip === 7 && item.key === 10) ||
    (rd === 4 && sp === 5 && flip === 9 && item.key === 11)
  );
};

export const isReaderAction02Disabled = (item, filters) => {
  const rd = filters[0],
    sp = filters[1],
    flip = filters[2],
    tb = filters[3];
  return (
    ((rd === 1 || rd === 2) && item.key === 13) ||
    (rd === 3 && sp === 5 && flip === 7 && tb === 11 && item.key === 13) ||
    (rd === 3 && sp === 5 && flip === 9 && tb === 10 && item.key === 12) ||
    rd === 4 ||
    (rd === 3 && sp === 6 && flip === 7)
  );
};
